export default __webpack_public_path__ + "static/media/brain.3bcfc2a4.svg";